module.exports = __webpack_public_path__ + "img/voice_content.64483447.png";